import pldLogo from "../../images/Logos/pld_logo.png";
import qpsLogo from "../../images/Logos/qps_benchmarking.png";

export const experienceData = [
  {
    link: "https://www.qpsbenchmarking.com/",
    logo: qpsLogo,
    company: "QPS Benchmarking",
    role: "Full stack developer",
    description:
      "Local company specialising in Health Care Benchmarking for the Asia-Pacific region",
    tasks: [
      "Full stack development including Django backend (Python), MySQL database (SQL), React frontend (Javascript) and many additional libraries",
      "Work as part of a small development team to create specialised web-based software solutions",
      "Updating existing code base with modern development techniques",
      "File management via GitLab",
      "Frequent code review of peer merge requests",
      "Frequent team liaising to achieve optimal solutions to issues",
      "Introduction of new features to the existing product",
      "Development of new products to meet client requirements",
      "Application of best practices to the development lifecycle",
      "Unit + Integration testing for both frontend & backend",
    ],
    durationFrom: "Apr 2020",
    durationTo: "Current",
    location: "Wollongong, NSW",
  },
  {
    link: "https://powerdesign.com.au/",
    logo: pldLogo,
    company: "Power Line Design",
    role: "Electrical Design Consultant",
    description:
      "Small electrical Level 3 Accredited Service Provider with projects spanning the entirety of NSW.",
    tasks: [
      "Solo self-driven development of desktop GUI apps and browser extensions to integrate work processes and improve productivity",
      "Solo self-driven development of AutoCAD script addons and VBA scripts to introduce automation software to the workplace",
      "Solo development of Python & Powershell scripts to facilitate the transition of company data restructuring",
      "Consistent output of Computer Aided Design drafting",
      "Frequent liaising with clients",
      "Detailed site visits and data collection (survey data, soil resistivity testing)",
      "Level 3 design/engineering for Supply Authority Networks (Endeavour Energy, Essential Energy)",
      "Project Management",
      "Auditing and inspection of peer designs",
      "Overseeing & coordinating multiple simultaneous projects",
      "Adherence to work requirements, Supply Authority standards & Electrical Standards",
      "Application of continuous improvement principles to the design process",
    ],
    durationFrom: "Mar 2017",
    durationTo: "Oct 2019",
    location: "Mittagong, NSW",
  },
];

export default experienceData;
